import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    supplierCode: Yup.number().required('Furnizorul este obligatoriu'),
    shopCode: Yup.string().required('Shop code este obligatoriu'),
    dsSupportTypeId: Yup.number().required('Tipul de suport este un câmp obligatoriu'),
    stock: Yup.number()
      .min(0, 'Stocul trebuie să fie pozitiv')
      .required('Campul este obligatoriu.')
  })

export const initialValues = {
  supplierCode: null as number | null,
  shopCode: null as string | null,
  dsSupportTypeId: null as number | null,
  stock: null as number | null
}
